module.exports = __webpack_public_path__ + "img/2_no.0ebb8b1c.svg";